import { Component, Input } from '@angular/core';
import { UserPreview } from '../../interfaces/user-preview.interface';
import { ConfigService } from '../../services/multi-clients/config.service';



@Component({
    selector: 'app-step-description',
    templateUrl: 'step-description.component.html',
    styleUrls: ['step-description.component.scss']
})
export class StepDescriptionComponent {

    @Input() readonly description: string;
    @Input() readonly extraDescription: string;
    @Input() readonly employee?: UserPreview;
    @Input() readonly showName: boolean = false;

    public hideViewThreeSixtyRank: boolean;

    constructor(
        private _configService: ConfigService
    ) {
        this.hideViewThreeSixtyRank = this._configService.settings.features.hideViewThreeSixtyRank;
    }

    public parsedDescription(description: string): string {
        return description.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }
}
